import { getMessages } from '../../../../../../../../store/constants';

export const ADD_NOTIFICATION_BUTTON_TEXT = getMessages().getText('button.notifications_before_due_date.add.text');
export const SAVE_NOTIFICATION_BUTTON_TEXT = getMessages().getText('button.notifications_before_due_date.save.text');
export const CANCEL_NOTIFICATION_BUTTON_TEXT = getMessages().getText('button.notifications_before_due_date.cancel.text');
export const NOTIFICATIONS_EDITING_POPUP_LABEL_TEXT = getMessages().getText('label.notifications_before_due_date.text');
